import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import { store } from './store'

//import firebase from 'firebase'
import firebase from 'firebase/app'
// import 'firebase/auth'
import 'firebase/firestore'

// import vue moment and local , locale is set in mounted() below
import vueMoment from 'vue-moment'
import moment from 'moment'
import 'moment/locale/es'

Vue.use(vueMoment, {
  moment
});

// Initialize Firebase
import { config } from './config'
firebase.initializeApp(config);
const db = firebase.firestore()
db.settings({ timestampsInSnapshots: true })

const initialBindings = [
  {
      name: 'aggregations',
      ref: db.collection('aggregations')
  },
  {
    name: 'senders',
    ref: db.collection('senders').where('verified','==',true)
  },
  {
    name: 'entities',
    ref: db.collection('entities')
  }
]

Vue.config.productionTip = false
/* eslint-disable no-unused-vars */
const unsubscribe = firebase.auth().onAuthStateChanged(
  (firebaseUser) => {
    new Vue({
      render: h => h(App),
      router,
      store,
      created() {
        firebase.auth().onAuthStateChanged((firebaseUser) => {
          if (firebaseUser) {
            store.dispatch('autoSignIn', firebaseUser)
            store.dispatch('setFirestoreBindings', initialBindings)
          }
        })
      },
      mounted() {
        this.$moment.locale('es') // set moment locale
      }
    }).$mount('#app')
    unsubscribe()
  }
)